import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router'
import { connect } from "react-redux";
import axios from "axios";
import SectionHeader from "./SectionHeader";
import Address from "../common/address";
import ProductList from "./products";
import Borrower from "./borrower";
import Title from "./Title";
import Instruction from "./AddInstruction";
import Banner from "../common/banner";


const divStyleSection = {
    backgroundColor: '#fff'
};


const d = async() => {
    axios.post(
        'https://api.mtsgrp.net/ordersubmit',
        JSON.stringify({ Type: "File", FileName: "2000000036.pdf" }, null, 2)
    ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
    });
}


const submitOrder = async (values, token) => {
    var a = await axios.post(
        'https://api.mtsgrp.net/ordersubmit',
        JSON.stringify(values, null, 2),
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return a.data;
}
class Section extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message:''
        };
    }
    closeBanner= () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    submit = (values) => {
        var b = submitOrder(values, this.props.session.session.credentials.accessToken);
        b.then((s) => {
            var myObject = JSON.parse(s);
            if (!myObject.Status)
                this.setState({ showBanner: true, message: myObject.Message });
            else this.props.complete(s);
            
        }, (r) => {
            this.setState({ showBanner: true, message: "Dam error" });
        })
    }


    render() {
        return (
            <>
                {this.state.showBanner && (<Banner Close={this.closeBanner} message={this.state.message} />)}
                <form onSubmit={this.props.handleSubmit(this.submit)}>
                    <div className="form-row" style={divStyleSection}>
                        <SectionHeader header="property address" iconname="icon-home"  />
                        <Address UseAddress={this.props.UseAddress}/>
                    </div>
                    <div className="form-row" style={divStyleSection}>
                        <SectionHeader header="product" iconname="icon-basket-loaded" />
                        <ProductList />
                    </div>

                    {this.props.Product && (
                        <div className="form-row" style={divStyleSection}>
                        <FormSection name="TitleData">
                            <Title />
                            </FormSection>
                        </div>
                    )}

                    <div className="form-row" style={divStyleSection}>
                        <SectionHeader header="borrower/coborrower" iconname="icon-user" />
                        <Borrower prefix="Borrower" />
                        <Borrower prefix="CoBorrower" />
                    </div>
                    <div className="form-row" style={divStyleSection}>
                        <SectionHeader header="Agent/Contact" iconname="icon-user" />
                            <Borrower prefix="Agent"/>
                    </div>
                    <div className="form-row" style={divStyleSection}>
                        <SectionHeader header="Additional Instructions" iconname="icon-note" />
                        <Instruction />
                    </div>

                    <div className="form-row">
                        <div className="col" style={{ backgroundColor: '#ffffff' }}>
                            <div className="float-right">
                                <div className="form-group">
                                    <button className="btn btn-primary" type="button" style={{ backgroundColor: `rgb(194,196,198)` }}>Reset</button>
                                    <button className="btn btn-primary" type="submit" style={{ marginLeft: '10px', backgroundColor: `rgb(141,199,231)` }}>Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </>

        );
    };
};

const validate = (formValues) => {
    const errors = {};

    if (!formValues.GoogleAddress && !formValues.Address) {
        errors.GoogleAddress = "Please select address from Google Address";
    }
    if (!formValues.BorrowerLastName) {
        errors.BorrowerLastName = "Please provide borrower last name";
    }
    if (formValues.BorrowerEmail && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.BorrowerEmail))) {
        errors.BorrowerEmail = 'Invalid email address';
    }
    if (formValues.AgentEmail && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.AgentEmail))) {
        errors.AgentEmail = 'Invalid email address';
    }
    return errors;
}

var orderform =  reduxForm({
    form: 'orderForm',
    validate
})(Section);

const selector = formValueSelector('orderForm')

orderform = connect(state => {
    const Product = selector(state, 'Appraisal');
    const UseAddress = selector(state, 'UseAddress');
    return {
        Product,
        UseAddress,
        session: state.session
    }
})(orderform);

export default orderform;
